export default __webpack_public_path__ + "static/media/mastercard.0c1b6390.svg";